module.exports = __webpack_public_path__ + "static/media/icon_checkbox_fill.2fbbd445.svg";